import { GetModelSummaryForClientApiV1ModelsClientClientIdSummaryGetApiResponse } from '~/api/sylvanus/typedefs.autogen';
import { sylvanus } from '~/services/serviceInstances';

type Response =
  GetModelSummaryForClientApiV1ModelsClientClientIdSummaryGetApiResponse;
interface Request {
  clientId: string;
}

// This API is used for SuperAdmin to get the model summary for a specific client
export const getModelsQuotaSummary = async ({
  clientId,
}: Request): Promise<Response> => {
  const response: Response = await sylvanus.get(
    `/models/client/${clientId}/summary`,
  );
  return response;
};
